export const ENROLL = 'enroll';
export const ENROLL_AUTOMATICALLY = 'autoenroll';
export const SHOW_PARTNER_SUPPORTED_ACCESS = 'showPartnerSupportedAccess';

export default {
  ENROLL,
};
